import { Button } from '@mui/material';
import { useTranslation } from "react-i18next";
import ExcelJS from 'exceljs';

const EquipmentStatusExcelDownload = ({excelDatas1, excelDatas2, excelDatas3, title, filename}) => {
    const { t } = useTranslation();
    
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet('Sheet1', {
      pageSetup: {
        paperSize: 9,
        orientation: 'landscape',
        horizontalCentered: true,
      },
    });
    ws.pageSetup.margins = {
      left: 0.7,
      right: 0.7,
      top: 0.75,
      bottom: 0.75,
      header: 0.3,
      footer: 0.3,
    };
  
    let excelData = [];
    excelData.push(
      {
        data: [title],
      },
      {
        data: [],
      }
    );

    excelData.push({data : excelDatas1});

    excelDatas2.forEach((item, index) => {
        excelData.push({data : item});
    });

    excelDatas3.forEach((item, index) => {
        if (index == 0)
            excelData.push({data : item});
        else
            excelData.push({data : [item[0].value, item[1].value, item[2].value, item[3], item[4], item[5], item[6], item[7]]});
    });

    excelData.push(
        {
            data: [t('message.common.text.how.to.write')],
        },
        {
            data: [t('message.common.text.how.to.write.status.one')],
        },
        {
            data: [t('message.common.text.how.to.write.status.two')],
        }
    );
    
    excelData.forEach((item, index) => {
      ws.getRow(index + 1).values = [...item.data];
    });
    
    let dataStartIdx = 4;
    // 셀 병합
    ws.mergeCells('A1:H1');
    ws.mergeCells('B3:C3');
    ws.mergeCells('G3:H3');

    excelDatas2.forEach((item, index) => {
        ws.mergeCells('A'+(dataStartIdx)+':C'+(dataStartIdx));
        ws.mergeCells('D'+(dataStartIdx)+':H'+(dataStartIdx));
        dataStartIdx++;
    });

    excelDatas3.forEach((item, index) => {
        if (index == 0) {
            ws.mergeCells('A'+(dataStartIdx)+':C'+(dataStartIdx));
        } else {
            if (item[2].col === 3) {
                ws.getRow(dataStartIdx).values = [item[2].value,'','',item[3],item[4],item[5],item[6],item[7]];
                ws.mergeCells('A'+(dataStartIdx)+':C'+(dataStartIdx));
            } else {
                if (item[0].col === 2) {
                    ws.getRow(dataStartIdx).values = [item[0].value,'',item[2].value,item[3],item[4],item[5],item[6],item[7]];
                    ws.mergeCells('A'+(dataStartIdx)+':B'+(dataStartIdx));
                } else if (item[1].col === 2) {
                    ws.getRow(dataStartIdx).values = [item[1].value,'',item[2].value,item[3],item[4],item[5],item[6],item[7]];
                    ws.mergeCells('A'+(dataStartIdx)+':B'+(dataStartIdx));
                }
            }
        }
        ws.mergeCells('E'+(dataStartIdx)+':F'+(dataStartIdx));
        ws.mergeCells('G'+(dataStartIdx)+':H'+(dataStartIdx));
        dataStartIdx++;
    });

    ws.mergeCells('A'+(dataStartIdx)+':H'+(dataStartIdx));
    dataStartIdx++;
    ws.mergeCells('A'+(dataStartIdx)+':H'+(dataStartIdx));
    dataStartIdx++;
    ws.mergeCells('A'+(dataStartIdx)+':H'+(dataStartIdx));

    // 폰트 사이즈, 굵기, 색상 변경
    ws.getCell('A1').font = { size: 18, bold: true, color: { argb: '000000' } };
    ws.getCell('A3').font = { bold: true };
    ws.getCell('D3').font = { bold: true };
    ws.getCell('F3').font = { bold: true };

    ws.getCell('A3').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('D3').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('F3').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('A'+(4+excelDatas2.length+excelDatas3.length)).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };

    ws.getCell('A'+(4+excelDatas2.length)).font = { bold: true };
    ws.getCell('D'+(4+excelDatas2.length)).font = { bold: true };
    ws.getCell('E'+(4+excelDatas2.length)).font = { bold: true };
    ws.getCell('G'+(4+excelDatas2.length)).font = { bold: true };

    ws.getCell('A'+(4+excelDatas2.length)).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('D'+(4+excelDatas2.length)).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('E'+(4+excelDatas2.length)).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };
    ws.getCell('G'+(4+excelDatas2.length)).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e5e5e5' } };

    // 정렬
    ws.getCell('A1').alignment = { horizontal: 'center', vertical: 'middle' };

    ws.getCell('A3').alignment = { horizontal: 'center', vertical: 'middle' };
    ws.getCell('B3').alignment = { horizontal: 'center', vertical: 'middle' };
    ws.getCell('D3').alignment = { horizontal: 'center', vertical: 'middle' };
    ws.getCell('E3').alignment = { horizontal: 'center', vertical: 'middle' };
    ws.getCell('F3').alignment = { horizontal: 'center', vertical: 'middle' };
    ws.getCell('G3').alignment = { horizontal: 'center', vertical: 'middle' };

    excelDatas2 && excelDatas2.forEach((item, index) => {
        ws.getCell('A'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('D'+(4+index)).alignment = { horizontal: 'center', vertical: 'middle' };
    });

    excelDatas3 && excelDatas3.forEach((item, index) => {
        if (index === 0) {
            ws.getCell('A'+(4+(excelDatas2.length)+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        } else {
            if (item[2].col === 3) {
                ws.getCell('A'+(4+(excelDatas2.length)+index)).alignment = { horizontal: 'center', vertical: 'middle' };
            } else {
                if (item[0].col === 2 || item[1].col === 2) {
                    ws.getCell('A'+(4+(excelDatas2.length)+index)).alignment = { horizontal: 'center', vertical: 'middle' };
                    ws.getCell('C'+(4+(excelDatas2.length)+index)).alignment = { horizontal: 'center', vertical: 'middle' };
                } else {
                    ws.getCell('A'+(4+(excelDatas2.length)+index)).alignment = { horizontal: 'center', vertical: 'middle' };
                    ws.getCell('B'+(4+(excelDatas2.length)+index)).alignment = { horizontal: 'center', vertical: 'middle' };
                    ws.getCell('C'+(4+(excelDatas2.length)+index)).alignment = { horizontal: 'center', vertical: 'middle' };
                }
            }
        }

        ws.getCell('D'+(4+(excelDatas2.length)+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('E'+(4+(excelDatas2.length)+index)).alignment = { horizontal: 'center', vertical: 'middle' };
        ws.getCell('G'+(4+(excelDatas2.length)+index)).alignment = { horizontal: 'center', vertical: 'middle' };
    });

    ws.getCell('A'+(4+excelDatas2.length+excelDatas3.length)).alignment =  { horizontal: 'center', vertical: 'middle' };
    
    // 테두리
    ws.getCell('A3').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('B3').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('D3').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('E3').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('F3').border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('G3').border = { top: { style: 'thin', color: { argb: '000000' } }, };

    excelDatas2 && excelDatas2.forEach((item, index) => {
        ws.getCell('A'+(4+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('D'+(4+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, };
    });

    excelDatas3 && excelDatas3.forEach((item, index) => {
        if (index === 0) {
            ws.getCell('A'+(4+(excelDatas2.length)+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        } else {
            if (item[2].col === 3) {
                ws.getCell('A'+(4+(excelDatas2.length)+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
            } else {
                if (item[0].col === 2 || item[1].col === 2) {
                    ws.getCell('A'+(4+(excelDatas2.length)+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
                    ws.getCell('C'+(4+(excelDatas2.length)+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
                } else {
                    ws.getCell('A'+(4+(excelDatas2.length)+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
                    ws.getCell('B'+(4+(excelDatas2.length)+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
                    ws.getCell('C'+(4+(excelDatas2.length)+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
                }
            }
        }

        ws.getCell('D'+(4+(excelDatas2.length)+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('E'+(4+(excelDatas2.length)+index)).border = { top: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        ws.getCell('G'+(4+(excelDatas2.length)+index)).border = { top: { style: 'thin', color: { argb: '000000' } } };
    });

    ws.getCell('A'+(4+excelDatas2.length+excelDatas3.length)).border =  { top: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('A'+(5+excelDatas2.length+excelDatas3.length)).border =  { top: { style: 'thin', color: { argb: '000000' } } };
    ws.getCell('A'+(6+excelDatas2.length+excelDatas3.length)).border =  { bottom: { style: 'thin', color: { argb: '000000' } } };

    // 가로 길이
    const col = [];
    for (let i = 0; i < 8; i++) {
        col.push({
            key: 'data',
            width: 15,
        });
    }
    ws.columns = col;
  
    // 세로 길이
    for (let i = 1; i <= excelData.length; i++) {
      let row = ws.getRow(i);
      row.height = 22;
    }
  
    // 줄 바꿈
  
    const download = () => {
        let promise = [];
        Promise.all(promise).then(() => {
            wb.xlsx.writeBuffer().then((b) => {
                let a = new Blob([b]);
                let url = window.URL.createObjectURL(a);
        
                let elem = document.createElement('a');
                elem.href = url;
                elem.download = filename;
                elem.click();
                elem.remove();
            });
        });
    }

    return (
        <Button variant="contained" color="primary" onClick={download} style={{margin:"3px"}}>
          {t('message.common.btn.excel.download')}
        </Button>
    )
};

export default EquipmentStatusExcelDownload;